
























import { Component, Prop, Vue } from 'vue-property-decorator'

import AppCarouselScroll from '@/components/AppCarouselScroll.vue'
import AppSectionBanner from '@/components/AppSectionBanner.vue'

@Component({
  components: {
    AppCarouselScroll,
    AppSectionBanner
  }
})
export default class extends Vue {
  @Prop(Array) readonly banners!: object[]
  @Prop(Boolean) readonly noCrop!: boolean

  visibleBannerId = null
}
